/**
 * WhatsApp service for FixMatePro
 * 
 * This service handles API calls to the WhatsApp integration endpoints
 */

import axios from 'axios';
import { getAuthToken } from './authService';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

/**
 * Set up axios instance with authentication
 */
const getAxiosInstance = async () => {
  const token = await getAuthToken();
  return axios.create({
    baseURL: API_URL,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }
  });
};

/**
 * Enable WhatsApp for a provider
 * 
 * @param {string} providerId - The provider ID
 * @param {object} data - The request data containing display_name
 * @returns {Promise} - The API response
 */
export const enableWhatsApp = async (providerId, data) => {
  const axiosInstance = await getAxiosInstance();
  return axiosInstance.post(`/api/whatsapp/providers/${providerId}/enable`, data);
};

/**
 * Disable WhatsApp for a provider
 * 
 * @param {string} providerId - The provider ID
 * @returns {Promise} - The API response
 */
export const disableWhatsApp = async (providerId) => {
  const axiosInstance = await getAxiosInstance();
  return axiosInstance.post(`/api/whatsapp/providers/${providerId}/disable`);
};

/**
 * List all virtual numbers (admin only)
 * 
 * @returns {Promise} - The API response
 */
export const listVirtualNumbers = async () => {
  const axiosInstance = await getAxiosInstance();
  return axiosInstance.get('/api/whatsapp/virtual-numbers');
};

/**
 * Create a new virtual number (admin only)
 * 
 * @param {object} data - The virtual number data
 * @returns {Promise} - The API response
 */
export const createVirtualNumber = async (data) => {
  const axiosInstance = await getAxiosInstance();
  return axiosInstance.post('/api/whatsapp/virtual-numbers', data);
};
